export default class AppConfigModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.timezone_id = model.timezone_id ? +model.timezone_id : 0;
        this.admin_reviewer_email = model.admin_reviewer_email ? model.admin_reviewer_email : '';

        this.is_paypal_enabled = !!model.is_paypal_enabled;
        this.is_authnet_enabled = !!model.is_authnet_enabled;
        this.authnet_merchant_login_id = model.authnet_merchant_login_id ? model.authnet_merchant_login_id : '';
        this.authnet_merchant_trans_key = model.authnet_merchant_trans_key ? model.authnet_merchant_trans_key : '';
        this.authnet_merchant_signature = model.authnet_merchant_signature ? model.authnet_merchant_signature : '';
        this.is_authnet_live = !!model.is_authnet_live;

        this.social_facebook_url = model.social_facebook_url ? model.social_facebook_url : '';
        this.social_twitter_url = model.social_twitter_url ? model.social_twitter_url : '';
        this.social_instagram_url = model.social_instagram_url ? model.social_instagram_url : '';
        this.social_pinterest_url = model.social_pinterest_url ? model.social_pinterest_url : '';

        this.run_src_import_job_every_xx_mins = model.run_src_import_job_every_xx_mins ? +model.run_src_import_job_every_xx_mins : 0;

        this.do_stop_src_import_job = !!model.do_stop_src_import_job;
        this.do_stop_daily_payments_job = !!model.do_stop_daily_payments_job;
    }

}
